<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-video-view
      :classMessage="messageClass"
      @update-files="updateFiles"
      @update-error="updateError(true)"
      :data-props="saveData"
      :nid="nid"
      :sid="main_sid"
    />
    <div class="text-left" v-bind:key="val.uuid" v-for="(val, index) in files">
      <component
        @delete="del(index)"
        @upload-file="fileUploaded(index, $event)"
        @upload-file-fail="fileUploadFail(index, $event)"
        :data-props="val"
        :clean-error="cleanError"
        @update-error="updateError(false)"
        :is="'FbVideoViewFile'"
        :nid="nid"
        :sid="main_sid"
      />
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Video'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <div>
        <div class="text-left">
          <h5 v-if="tempData.label">{{ tempData.label | token_replace(nid) }}</h5>
          <p>{{ tempData.helptext | token_replace(nid) }}</p>
        </div>
        <div class="text-left upload-link">
          <md-button class="md-primary">
            <md-icon>cloud_upload</md-icon>
            <span>Upload File</span>
          </md-button>
          <input
            accept="video/mp4, video/webm, video/ogg, .mp4, .webm, .ogv, .mov"
            style="display:none"
            type="file"
            ref="inputFile"
          />
        </div>
      </div>
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help text</label>
          <md-input v-model="tempData.helptext"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbVideoView from "./FbVideoView.vue";
import FbVideoViewFile from "./FbVideoViewFile.vue";

export default {
  name: "FbVideo",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true,
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(
        this.saveData.required === true &&
        this.files.filter((el) => {
          if (el.uuid && el.uuid != "") {
            return true;
          }
          return false;
        }).length == 0
      );
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: this.files
            .filter((el) => {
              return el.type == "file" && el.uuid && el.uuid != "";
            })
            .map((el) => {
              return {
                link: el.link,
                type: el.type,
                name: el.name,
                uuid: el.uuid,
                uri: el.uri,
                filemime: el.filemime,
              };
            }),
          type: this.element.type,
        };
      }
      return undefined;
    },
  },
  components: {
    FbVideoView,
    FbVideoViewFile,
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.files = window.drupalSettings.form_builder[this.nid]["submissions"][
        this.sid
      ][this.element.uuid].value.map((el) => {
        if (el.type == "file") {
          return {
            link: el.name,
            type: "file",
            buffer: undefined,
            name: el.name,
            uuid: el.uuid,
            uri: el.uri,
            filemime: el.filemime,
          };
        }
      });
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
    this.options = {
      controls: true,
      fluid: true,
    };
  },
  data() {
    return {
      files: [],
      tempData: {
        label: this.element.data.label || "",
        helptext: this.element.data.helptext || "",
        required: this.element.data.required || false,
      },
      saveData: {
        label: this.element.data.label || "",
        helptext: this.element.data.helptext || "",
        required: this.element.data.required || false,
      },
      cleanError: false,
    };
  },
  methods: {
    updateError(value) {
      this.cleanError = value;
    },
    updateFiles(file) {
      this.files = this.files.concat([
        {
          link: file.name,
          type: "file",
          buffer: file.buffer,
          name: file.name,
          uuid: "",
          uri: "",
          filemime: "",
        },
      ]);
    },
    fileUploaded(index, file) {
      this.files[index].name = file.name;
      this.files[index].uuid = file.uuid;
      this.files[index].uri = file.uri;
      this.files[index].filemime = file.filemime;

      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    fileUploadFail(index) {
      this.files.splice(index, 1);
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    del(index) {
      this.files.splice(index, 1);
    },
  },
  watch: {
    files: function files() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
  },
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
